import React from "react";
import { LINKS } from "@shared/constants";
import classnames from "classnames";

import { ButtonProps } from "./Button";

export const ButtonMailToSales: React.FC<ButtonProps> = ({ children = "Contact Sales Team", className }) => {
  return (
    <a
      target="_blank"
      className={classnames("button-component button-primary", className)}
      href={LINKS.DEMO_CALENDAR}
      rel="external noreferrer"
    >
      {children}
    </a>
  );
};
